import React from 'react';
import { Flex } from '@mantine/core';

import { QueryClient } from '@tanstack/react-query';
import {
  MRT_ToggleGlobalFilterButton,
  MRT_ToggleFiltersButton,
  MRT_ShowHideColumnsButton,
  MRT_TableInstance,
} from 'mantine-react-table';
import { InternalRefreshButton } from './InternalRefreshButton';
import { InternalTogglePreviewButton } from './InternalTogglePreviewButton';

interface DefaultToolBarInternalActionsProps {
  table: MRT_TableInstance<any>;
  queryClient: QueryClient;
}

export const DefaultToolBarInternalActions: React.FC<
  DefaultToolBarInternalActionsProps
> = ({ table, queryClient }) => {
  return (
    <Flex align="center" gap="0.313rem">
      <InternalRefreshButton queryClient={queryClient} />
      <InternalTogglePreviewButton />
      <MRT_ToggleGlobalFilterButton table={table} />
      <MRT_ToggleFiltersButton table={table} />
      <MRT_ShowHideColumnsButton table={table} />
    </Flex>
  );
};
